import * as angular from 'angular';

/**
 * Fullscreen toggle service.
 */
export class FullscreenToogleService {
    constructor(
        private $location: ng.ILocationService,
        private activeLocationService,
        private $sessionStorage: ngStorage.StorageService,
        private $timeout: ng.ITimeoutService
    ) {}

    public checkAutoToggle(): void {
        if (this.activeLocationService.isActive('/reporting')) {
            if (angular.isDefined(this.isManualFullscreenReportArea())) {
                this.toggleFullScreen(
                    false,
                    !this.isManualFullscreenReportArea()
                );
            } else {
                this.toggleFullScreen(false, false);
            }
        } else {
            if (angular.isDefined(this.isManualFullscreenRegularArea())) {
                this.toggleFullScreen(
                    false,
                    !this.isManualFullscreenRegularArea()
                );
            } else {
                this.toggleFullScreen(false, true);
            }
        }
    }

    private isFullscreen(): boolean {
        return $('.container-fluid.fullscreen-adjustable').hasClass(
            'container-fluid'
        );
    }

    public setManualFullscreenReport(value): void {
        this.$sessionStorage['manualFullscreenStateReport'] = value;
    }

    public setManualFullscreenRegular(value): void {
        this.$sessionStorage['manualFullscreenStateRegular'] = value;
    }

    private isManualFullscreenReportArea(): boolean {
        return this.$sessionStorage['manualFullscreenStateReport'];
    }

    private isManualFullscreenRegularArea(): boolean {
        return this.$sessionStorage['manualFullscreenStateRegular'];
    }

    public toggleFullScreen(manual: boolean, isFullscreen: boolean): void {
        this.$timeout(() => {
            let toggleButton = $('#togglefullscreen');
            let toggleIcon = $('#togglefullscreen > i');

            if (isFullscreen) {
                let toWindowed = $('.container-fluid.fullscreen-adjustable');
                toWindowed.removeClass('container-fluid');
                toWindowed.addClass('container');
                toggleButton.removeClass('active');
                toggleIcon.removeClass('fa-compress');
                toggleIcon.addClass('fa-expand');
            } else {
                let toFullscreen = $('.container.fullscreen-adjustable');
                toFullscreen.removeClass('container');
                toFullscreen.addClass('container-fluid');
                toggleButton.addClass('active');
                toggleIcon.removeClass('fa-expand');
                toggleIcon.addClass('fa-compress');
            }

            if (manual) {
                if (this.activeLocationService.isActive('/reporting')) {
                    this.setManualFullscreenReport(this.isFullscreen());
                } else {
                    this.setManualFullscreenRegular(this.isFullscreen());
                    //fullscreen in regular area overrides any session setting for reporting area
                    if (this.isFullscreen()) {
                        this.setManualFullscreenReport(this.isFullscreen());
                    }
                }
            }
        }, 100);
    }
}

angular
    .module('app')
    .service('fullscreenToogleService', FullscreenToogleService);
